import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { toggleDocumentTypeSelection } from '../../../ducks/DocumentTypesDucks';

const DocumentTypesListItem = ({ documentType }) => {
  const dispatch = useDispatch();

  const callToggleDocumentTypeSelection = useCallback(
    documentTypeId => dispatch(toggleDocumentTypeSelection(documentTypeId)),
    [dispatch, documentType]
  );

  return(
    <DocumentType
      onClick={() => callToggleDocumentTypeSelection(documentType.id)}
      selected={documentType.selected}>
      {documentType.name}
    </DocumentType>
  ) 
} 

const DocumentType = styled.div`
  align-items: center;
  background: #e9e9e9;
  border-radius: 5px;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  height: 75px;
  justify-content: center;
  margin: 5px;
  overflow: hidden;
  padding: 10px;
  text-align: center;
  transform: scale(1);
  transition: .2s all ease;
  user-select: none;
  width: calc(33.3% - 10px);

  &:hover {
    transform: scale(1.05);
    background: #f7f7f7;
    box-shadow: 1px 2px 3px rgba(0,0,0,.3);
  }

  ${({ selected }) => selected && `
    color: white;
    background: #486c81;

    &:hover {
      background: #6e8da8;
    }
  `}
`

export default DocumentTypesListItem;



// WEBPACK FOOTER //
// ./src/components/DocumentTypesList/DocumentTypesListItem/index.js